import ClientCheckpointMaster from "@pages/Checkpoint/Master";
import CheckPointReleaseVendor from "@pages/Checkpoint/Master/ReleseToVendor";
import AssignToPECompliance from "@pages/Checkpoint/Master/AssignToPE";
import MasterAddToTracker from "@pages/Checkpoint/Master/AddToTracker";
import ClientVendorCheckpoint from "@pages/Checkpoint/VendorCheckpoints";
import ClientReleaseDates from "@pages/Checkpoint/ReleaseDates";
import ClientReleaseDatesNew from "@pages/Checkpoint/ReleaseDatesNew";
import ClientReleaseDatesNewVendorHistory from "@pages/Checkpoint/ReleaseDatesNew/Accordian/VendorHistory/VendoryHistory";
import ClientPECompliance from "@pages/Checkpoint/PECompliance";
import ClientLicense from "@pages/Checkpoint/Licence";
import EmailReminders from "@pages/Checkpoint/EmailReminder";
import CheckpointAssignTask from "@pages/Checkpoint/Master/AssignTask";
import AssignedTasks from "@pages/Checkpoint/AssignedTasksList";
import AssignedTaskConfiguration from "@pages/Checkpoint/AssignedTasksList/configure";

export const CheckpointRoutes = [
	{
		path: "/repository/checkpoint/master",
		name: "repository_checkpoint_company_master",
		component: ClientCheckpointMaster,
	},
	{
		path: "/checkpoint/release-to-vendor",
		name: "repository_checkpoint_vendor_checkpoints",
		component: CheckPointReleaseVendor,
	},
	{
		path: "/checkpoint/assign-to-PE",
		name:"repository_checkpoint_pe_compliance",
		component: AssignToPECompliance,
	},
	{
		path: "/checkpoint/add-to-tracker",
		name: "repository_checkpoint_company_master",
		component: MasterAddToTracker,
	},
	{
		path: "/checkpoint/assign-task",
		name: "repository_checkpoint_assigned_tasks",
		component: CheckpointAssignTask,
	},
	{
		path: "/repository/checkpoint/assign-task-configure",
		name: "repository_checkpoint_assigned_tasks",
		component: AssignedTaskConfiguration,
	},
	{
		path: "/repository/checkpoint/assigned-tasks",
		name: "repository_checkpoint_assigned_tasks",
		component: AssignedTasks,
	},
	{
		path: "/repository/checkpoint/vendor-checkpoints",
		name: "repository_checkpoint_vendor_checkpoints",
		component: ClientVendorCheckpoint,
	},
	{
		path: "/repository/checkpoint/release-dates",
		name: "repository_checkpoint_release_date",
		component: ClientReleaseDates,
	},
	{
		path: "/repository/checkpoint/release-dates-new",
		name: "repository_checkpoint_release_date",
		component: ClientReleaseDatesNew,
	},
	{
		path: "/repository/checkpoint/release-dates-new/vendor-history/:id",
		name: "repository_checkpoint_release_date_new_vendor_history",
		component: ClientReleaseDatesNewVendorHistory,
	},
	{
		path: "/repository/checkpoint/PE-compliance",
		name: "repository_checkpoint_pe_compliance",
		component: ClientPECompliance,
	},
	{
		path: "/repository/checkpoint/license",
		name:"repository_checkpoint_license",
		component: ClientLicense,
	},
];
